export default Object.freeze({
  NONE: 0,
  LOCAL_STOCK: 1,
  PACKETA: 2,
  CESKA_POSTA_BALIKOVNA: 3,
  PPL: 4,
  CESKA_POSTA_NAPOSTU: 5,
  PENGUIN_BOX: 6,
  PENGUIN_BOX_DIRECT: 7,
  CESKA_POSTA_BALIK_DO_RUKY: 8,
  GLS: 9,
  PENGUIN_LOGISTIC: 10,
  DPD: 11,
  PENGUIN_MINI: 12,
  PACKETA_ADDRESS_DELIVERY: 13,
  WEDO: 14,
  WEDO_ADDRESS_DELIVERY: 15,
  PPL_ADDRESS_DELIVERY: 16,
  PARTNER_SALONS: 17,
});
